import { liveRoutes } from './live_routes';
import ProtectedRoute from './protected_route';
import { stagingRoutes } from './staging_routes';
import { UserRole } from '../params/redux';

export const protectedRoute = (Component: JSX.Element, roles: UserRole[]) => (
    <ProtectedRoute roles={roles}>{Component}</ProtectedRoute>
);

export const router = process.env.REACT_APP_MODE === 'dev' ? stagingRoutes : liveRoutes;